// @flow
import React from 'react';
import Spinner from 'spin.js';

const DEFAULT_OPTS = {
  lines: 7, // The number of lines to draw
  length: 0, // The length of each line
  width: 2, // The line thickness
  radius: 2, // The radius of the inner circle
  corners: 1, // Corner roundness (0..1)
  rotate: 0, // The rotation offset
  direction: 1, // 1: clockwise, -1: counterclockwise
  color: '#fff', // #rgb or #rrggbb or array of colors
  speed: 2, // Rounds per second
  trail: 60, // Afterglow percentage
  shadow: false, // Whether to render a shadow
  hwaccel: true, // Whether to use hardware acceleration
  className: 'SpinnerComponent__Animation', // The CSS class to assign to the spinner
  zIndex: 2e9, // The z-index (defaults to 2000000000)
  top: '0%', // Top position relative to parent
  right: '0%' // Left position relative to parent
};

export default class LegacySpinner extends React.PureComponent<{}> {
  spinner: Spinner;
  spinnerElement: ?HTMLDivElement;

  componentDidMount() {
    this.spinner = new Spinner(DEFAULT_OPTS).spin(this.spinnerElement);
  }

  componentWillUnmount() {
    this.spinner.stop();
  }

  render() {
    return (
      <div
        className="SpinnerComponent"
        ref={(spinnerElement) => this.spinnerElement = spinnerElement}
      />
    );
  }
}
